import React from 'react';

export default function LoadingModal({ message = 'Loading…' }) {
  return (
    <div className="modal-backdrop">
      <div
        className="modal-content"
        style={{
          padding: '2rem',
          textAlign: 'center',
          backgroundColor: '#fff',
          borderRadius: '12px',
          boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
        }}
      >
        <div
          className="spinner"
          style={{
            border: '4px solid rgba(0, 0, 0, 0.1)',
            borderTop: '4px solid #7CB0A1',
            borderRadius: '50%',
            width: '2rem',
            height: '2rem',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem',
          }}
        />
        <p style={{ fontSize: '1rem', color: '#374151' }}>{message}</p>
      </div>
    </div>
  );
}
